import React, { useState, useEffect } from 'react';
import Button from 'components/generics/Button';
import InputLabel from 'components/generics/InputLabel';


const EditFunctionsCategoriesForm = props => {
    const [ functionsCategories, setFunctionsCategories ] = useState(props.currentFunctionsCategories)
  
    useEffect(
      () => {
        setFunctionsCategories(props.currentFunctionsCategories)
      },
      [ props ]
    )
    // You can tell React to skip applying an effect if certain values haven’t changed between re-renders. [ props ]
  
    const handleInputChange = (name, value) => {
      setFunctionsCategories({ ...functionsCategories, [name]: value })
    }
  
    return (
      <form className="form-client"
        onSubmit={event => {
          event.preventDefault()
          props.handleUpdateFunctionsCategories(functionsCategories.id, functionsCategories)
        }}
      >

      <InputLabel
				name="name"
				type="text"
				value={functionsCategories.name}
				defaultStyle='secondary'
				label="Nom"
				onChange={(e) => { handleInputChange('name', e); }}/>

        <div className="div-button">
          <Button
            type="submit"
            defaultStyle="btn btn-primary"
            text="Enregistrer"
            textColor="primary"
          />
          <Button 
            type="button"
            text="Annuler"  
            onClick={() => props.setEditing(false)} 
            defaultStyle="btn btn-secondary"
          />
        </div>
      </form>
    )
  }

export default EditFunctionsCategoriesForm;
